import { KeyboardEventHandler } from 'react';

export const resizeTextarea: KeyboardEventHandler = (e) => {
  const el = e.target as HTMLInputElement;
  el.style.height = `${el.scrollHeight}px`;
  el.style.paddingTop = '30px';
  el.style.paddingBottom = '15px';
};
